import { VelvetHanger } from "./VelvetHanger";

const MASK = (url) => ({
  WebkitMaskImage: `url(${url})`, maskImage: `url(${url})`,
  WebkitMaskSize: "100% 100%", maskSize: "100% 100%",
  WebkitMaskRepeat: "no-repeat", maskRepeat: "no-repeat",
});

export const HangingGarment = ({ cutout, item, onOpen }) => (
  <button type="button" onClick={onOpen} data-testid={`thrift-item-select-${item.id}`} aria-label={item.title} className="relative block w-[170px] pt-[50px]">
    <span className="relative mx-auto block w-fit">
      <img src={cutout} alt={item.title} draggable={false} data-testid="thrift-item-cutout" className="block h-auto w-auto max-w-[170px] max-h-[300px] sm:max-h-[350px] select-none [filter:drop-shadow(0_18px_14px_rgba(60,40,20,0.30))_drop-shadow(0_2px_2px_rgba(60,40,20,0.25))]" />
      <span
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none mix-blend-soft-light"
        style={{ background: "linear-gradient(100deg, rgba(255,255,255,0.35) 0%, rgba(255,255,255,0) 38%, rgba(0,0,0,0) 62%, rgba(0,0,0,0.35) 100%), linear-gradient(180deg, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0) 14%)", ...MASK(cutout) }}
      />
    </span>
    <span className="absolute inset-x-0 top-0 z-10"><VelvetHanger price={item.price} /></span>
  </button>
);
